import http from './http';

// 查询实时库存列表
export const fetchGoodsStockList = (params) => {
  return http({
    url: '/goods/storage/v2/realtime',
    method: 'POST',
    data: params,
  });
};

// 查询实时库存头部数据
export const fetchGoodsStorageSummary = () => {
  return http({
    url: '/goods/storage/summary',
    method: 'GET',
  });
};

// 查询标准库存列表
export const fetchStandardStockList = () => {
  return http({
    url: '/goods/storage/v2/permanent/rooms',
    method: 'GET',
  });
};

// 根据房间号查询标准库存
export const fetchStandardStockRoom = (params) => {
  return http({
    url: '/goods/storage/permanent/getByRoomid',
    method: 'GET',
    params,
  });
};

// 根据仓库id查询标准库存
export const fetchStandardStockStorage = (params) => {
  return http({
    url: '/goods/storage/permanent/storage',
    method: 'GET',
    params,
  });
};

// 标准库存补货保存
export const fetchSaveStandardStockRoom = (params) => {
  return http({
    url: '/goods/storage/permanent/roomsByRoomId',
    method: 'POST',
    data: params,
  });
};

// 查询门店列表
export const fetchRoomsList = () => {
  return http({
    url: '/rooms/list',
    method: 'GET',
  });
};

// 批量设置查询标准库存列表
export const fetchBatchRecordList = () => {
  return http({
    url: '/goods/storage/simple-list',
    method: 'GET',
  });
};

// 获取门店仓库扣除配置
export const fetchStorageStatus = () => {
  return http({
    url: '/goods/storage/storageSetting',
    method: 'GET',
  });
};

// 修改门店仓库扣除配置
export const fetchUpdateStorageStatus = (data) => {
  return http({
    url: '/goods/storage/storageSetting',
    method: 'PUT',
    data,
  });
};

// 工资单导入模板下载
export const exportExcel = (data) => {
  return http({
    method: 'POST',
    url: `/goods/storage/query-list/excel-export`,
    responseType: 'blob',
    data,
  });
};
